import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Handler from "../../Helpers/Components/Handler";
import DatePicker from "react-multi-date-picker";
import PageChanger from "../../Helpers/Components/Pagination1";
import moment from "moment";
import { getCookie } from "../../Helpers/Utils";
import Select from 'react-select'
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder";

const Report = () => {
    const { id } = useParams()
    const [stage, setStage] = useState('Booked')
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(10)
    const [stageCounts, setStageCounts] = useState({})
    const [next, setNext] = useState(false)
    const [report, setReport] = useState([])
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [filterDate, setFilterDate] = useState({ from: "", to: "" })
    const person = getCookie('person')
    const getDetails = async () => {
        const url = getCookie('person') === "admin" ? "/admin/subadmin" : "/subadmin"
        const response = await Handler({ url: `${url}/per/report/${page}?count=${count || 10}`, data: { stage, staffId: id, ...(filterDate?.from ? { from: moment(new Date(filterDate?.from)).format("DD-MM-YYYY"), to: filterDate?.to ? moment(new Date(filterDate?.to)).format("DD-MM-YYYY") : moment(new Date()).format("DD-MM-YYYY") } : {}) }, method: 'post' })
        setLoading(true)
        if (response?.success) {
            setReport(response?.data?.current)
            setNext(response?.data?.next)
            setStageCounts(response?.data?.stageCounts)
        } else {
            setReport([])
            setNext(false)
            setStageCounts({})
        }
        setLoading(false)
    }
    const setPageNo = (value) => {
        setPage(value)
    }
    useEffect(() => {
        if (id || person === "subadmin") {
            getDetails()
        }
    }, [id, stage, filterDate, count, page])

    return (
        <React.Fragment>
            <div className="row mt-5">
                <div className="col-md-2">
                    <div className="card px-2 py-3">
                        <div className="text-theme title text-center mb-3">Status</div>
                        <ul className="d-flex flex-column gap-2">
                            <li><button className={`btn report-btn ${stage === "Booked" ? "active-report" : ""}`} onClick={() => setStage("Booked")}>Booked : {stageCounts?.Booked || 0}</button></li>
                            <li><button className={`btn report-btn ${stage === "Ongoing" ? "active-report" : ""}`} onClick={() => setStage("Ongoing")}>Ongoing : {stageCounts?.Ongoing || 0}</button></li>
                            <li><button className={`btn report-btn ${stage === "Cancelled" ? "active-report" : ""}`} onClick={() => setStage("Cancelled")}>Cancelled : {stageCounts?.Cancelled || 0}</button></li>
                            <li><button className={`btn report-btn ${stage === "Pending" ? "active-report" : ""}`} onClick={() => setStage("Pending")}>Pending : {stageCounts?.Pending || 0}</button></li>
                            <li><button className={`btn report-btn ${stage === "Completed" ? "active-report" : ""}`} onClick={() => setStage("Completed")}>Pickup : {stageCounts?.Completed || 0}</button></li>
                            <li><button className={`btn report-btn ${stage === "Credit" ? "active-report" : ""}`} onClick={() => setStage("Credit")}>Credit : {stageCounts?.Credit || 0}</button></li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-10">
                    <div className="card p-3">
                        <div className="mb-3 text-center text-uppercase text-theme fs-5 fw-medium">
                            {stage}
                        </div>
                        <div className="row align-items-center mb-4">
                            <div className="col-md-6 d-flex">
                                <div className="me-2 filter-date datepicker-top">
                                    <DatePicker
                                        autoComplete="off"
                                        selected={filterDate?.from}
                                        id="from"
                                        showYearDropdown
                                        showMonthDropdown
                                        placeholder="From"
                                        timeIntervals={15}
                                        placeholderText="From"
                                        value={filterDate?.from || ""}
                                        onChange={(date) => { setFilterDate((prevValues) => ({ ...prevValues, from: date })) }}
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control form_input text-uppercase me-2"
                                    />
                                </div>
                                <div className="me-2 filter-date datepicker-top">
                                    <DatePicker
                                        autoComplete="off"
                                        selected={filterDate?.to}
                                        id="from"
                                        showYearDropdown
                                        showMonthDropdown
                                        placeholder="To"
                                        placeholderText="To"
                                        timeIntervals={15}
                                        onChange={(date) => { setFilterDate((prevValues) => ({ ...prevValues, to: date })) }}
                                        dateFormat="dd/MM/yyyy"
                                        value={filterDate?.to || ""}
                                        minDate={filterDate?.from}
                                        disabled={filterDate?.from === "" ? true : false}
                                        className="form-control form_input text-uppercase"
                                    />
                                </div>
                                {filterDate?.from === "" ? "" :
                                    <button className="py-0 px-1 d-flex align-items-center cancelX" onClick={() => { setFilterDate({ from: "", to: "" }) }}>
                                        <i className="fa-solid fa-circle-xmark text-theme"></i>
                                    </button>}
                            </div>
                        </div>
                        <div className="overflow list-table">
                            <table className="table-bg table" borderless="true">
                                <thead>
                                    <tr>
                                        <th>Booking ID </th>
                                        <th> Customer ID  </th>
                                        <th> Car ID  </th>
                                        <th> Booked At  </th>
                                        <th>Delivery Date </th>
                                        <th>Pickup Date </th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        loading ? <TablePlaceHolder count={7} /> :
                                            (report?.length ? report?.map((element, i) => {
                                                return (
                                                    <tr key={i} id={i} className="align-middle">
                                                        <td><a href={`/booking/view/${element?.bookingId}`}  >{element?.bookingId}</a></td>
                                                        <td><a href={`/customer/view/${element?.customerId}`}>{element?.customerId}</a></td>
                                                        <td> <a href={`/car/view/${element?.carId}`}>{element?.carid}</a> </td>
                                                        <td>{element?.createdAt ? moment(element?.createdAt)?.format("DD-MM-YYYY") : ""}</td>
                                                        <td>{element?.deliveryDetails?.delivery ? moment(element?.deliveryDetails?.delivery)?.format("DD-MM-YYYY hh:mm A") : ""}</td>
                                                        <td>{element?.pickupDetails?.pickup ? moment(element?.pickupDetails?.pickup)?.format("DD-MM-YYYY hh:mm A") : ""}</td>
                                                        <td>{element?.status}</td>
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan={7} className="text-center">No Data Found</td></tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex align-items-center justify-content-end mt-3">
                            <span className="me-2 fw-medium"> Page Count:  </span>
                            <Select
                                className="inside-select"
                                isDisabled={loading}
                                onChange={(selectedoption) => {
                                    setCount(Number(selectedoption?.value))
                                    setPageNo(1)
                                }}
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                        boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                        "&:hover": {
                                            borderColor: "#f16436"
                                        }
                                    }),
                                    option: (style, state) => ({
                                        ...style,
                                        backgroundColor: state.isSelected
                                            ? "#f16436"
                                            : (state.isFocused || state.isActive)
                                                ? "#f164361a"
                                                : "white",
                                        color: state.isSelected ? "white" : "black"
                                    })
                                }}
                                value={count ? { label: count, value: count } : { label: 10, value: 10 }}
                                options={[
                                    { label: 10, value: 10 },
                                    { label: 20, value: 20 },
                                    { label: 30, value: 30 },
                                    { label: 40, value: 40 },
                                    { label: 50, value: 50 },
                                ]}
                                placeholder="PageNo"
                            />
                        </div>
                        <PageChanger previousValue={Number(page) > 1} nextValue={next} current={Number(page)} onPageChange={setPageNo} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Report;